import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { List, ListItemButton, ListItemText, Menu } from "@mui/material";
import { AngleIcon } from "../../../Icons";

const HeaderAi = () => {
  const [headerMenuEl, setHeaderMenuEl] = useState(null);
  const headerMenuOpen = Boolean(headerMenuEl);
  const headerMenuOpenReq = (event) => {
    setHeaderMenuEl(event.currentTarget);
  };
  const headerMenuClose = () => {
    setHeaderMenuEl(null);
  };

  return (
    <React.Fragment>
      <div
        className={`managepro6ix-layout-header-bottom-menu-link ${
          headerMenuOpen ? "active" : ""
        }`}
        id="header-ai-menu-button"
        aria-controls={headerMenuOpen ? "header-ai-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={headerMenuOpen ? "true" : undefined}
        onClick={headerMenuOpenReq}
      >
        6ix AI
        {headerMenuOpen ? <AngleIcon up /> : <AngleIcon small />}
      </div>

      <Menu
        id="header-ai-menu"
        anchorEl={headerMenuEl}
        open={headerMenuOpen}
        onClose={headerMenuClose}
        MenuListProps={{
          "aria-labelledby": "header-ai-menu-button",
        }}
        className="managepro6ix-layout-header-bottom-menu-link-dropdown managepro6ix-layout-header-bottom-menu-link-dropdown-users"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <List
          component="nav"
          className="managepro6ix-layout-header-bottom-menu-link-dropdown-users-list"
        >
          <ListItemButton
            className="managepro6ix-layout-header-bottom-menu-link-dropdown-users-list-item"
            component={NavLink}
            to="/ai"
            onClick={headerMenuClose}
          >
            <ListItemText
              className="managepro6ix-layout-header-bottom-menu-link-dropdown-users-list-item-text"
              primary="Dashboard"
            />
          </ListItemButton>
          <ListItemButton
            className="managepro6ix-layout-header-bottom-menu-link-dropdown-users-list-item"
            component={NavLink}
            to="/ai/topics"
            onClick={headerMenuClose}
          >
            <ListItemText
              className="managepro6ix-layout-header-bottom-menu-link-dropdown-users-list-item-text"
              primary="Topics"
            />
          </ListItemButton>
        </List>
      </Menu>
    </React.Fragment>
  );
};

export default HeaderAi;
